export default __webpack_public_path__ + "static/media/activity_ticket_star.35156206.svg";